import { createReducer, on } from '@ngrx/store';
import { loadConfig } from '../actions/config.actions';
import { initialState } from '../states/config.state';

export const configReducer = createReducer(
  initialState,
  on(loadConfig, (state, { data }) => {
    return {
      ...state,
      data,
    };
  })
);
